// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn:focus {\n  box-shadow: none !important;\n}\n\nbody {\n  background-color: #151515;\n}\n\n.placeholder-container {\n  width: 250px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: -1;\n  text-align: center;\n  color: white !important;\n}\n\n#placeholder-img {\n  width: 100%;\n  padding: 2px;\n}", ""]);
// Exports
module.exports = exports;
